function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useThrottle } from "../../hooks/useThrottle";
import { NodesUtil } from "../NodesUtil";
import isBlank from "@sedan-utils/is-blank";
import { Input } from "antd";
import { default as classNames, default as cls } from "classnames";
import React, { useEffect, useRef } from "react";
import style from "./JsonNode.module.scss";
export var Json = function Json(props) {
  var _props$textAreaValue, _props$textAreaValue2;
  var inputBoxRef = useRef(null);
  var value = ((_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.results[0].content) || "";
  useThrottle(function () {
    if (value.length > 260 && inputBoxRef.current && props.showStopGenerateBtn === true) {
      // 滚动到底部
      var distance = inputBoxRef.current.scrollHeight - inputBoxRef.current.clientHeight;
      inputBoxRef.current.scrollTop = distance;
    }
  }, 100, [value, props.showStopGenerateBtn]);
  useEffect(function () {
    if (props.showStopGenerateBtn === false) {
      setTimeout(function () {
        // 滚动到顶部
        if (inputBoxRef.current) {
          inputBoxRef.current.scrollTop = 0;
        }
      }, 200);
    }
  }, [props.showStopGenerateBtn]);
  var textNodeClassName = cls(style["custom-node"], style["design-text"], (props.isLongPress || props.checkNodeArr && props.checkNodeArr.includes(props.id)) && "nopan ".concat(NodesUtil.constants.NO_WHEEL), style["guide-textnode-disable"], props.enableFeedback && style["target"], !props.disableAddPreview && props.isStartNode && !props.isStartNodeAdded && !(props !== null && props !== void 0 && props.isStaticApp) ? style.reservedButtonHeight : "");
  var reSizeStyle = {
    width: undefined,
    height: undefined
  };
  if (props.resizeEventParams) {
    reSizeStyle.width = props.resizeEventParams.width;
    if (props.resizeEventParams.height) {
      reSizeStyle.height = props.resizeEventParams.height - 70;
    } else {
      reSizeStyle.height = "auto";
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: textNodeClassName,
    ref: inputBoxRef,
    style: reSizeStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: style["text-content"]
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["input-mask"], " ").concat(props.isLongPress ? style["hidden-mask"] : "", " ").concat(!props.disableAddPreview ? style["previewing"] : "")
  }, !props.isLongPress && (isBlank(value) || typeof value === "string") ? /*#__PURE__*/React.createElement("p", {
    className: "".concat(style["alternate-text"], " ").concat(isBlank(value) ? style["place-color"] : "")
  }, typeof value === "string" && value || props.placeholder || "Enter Input") : null), /*#__PURE__*/React.createElement("div", {
    className: classNames(style["text-textArea"], _defineProperty(_defineProperty({
      nodrag: props.isLongPress
    }, style["show-text-textArea"], props.isLongPress), style["max-textarea-height"], !props.isResized))
  }, /*#__PURE__*/React.createElement(Input.TextArea, {
    className: "".concat(style.textarea, " ").concat(!props.isLongPress ? "hidden-input" : ""),
    value: ((_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2[0].results[0].content) || "",
    ref: props.inputRef,
    onPressEnter: props.onTextAreaEnter,
    onChange: function onChange(e) {
      return props.setTextAreaValueWithParam({
        content: e.target.value
      });
    },
    onBlur: function onBlur(e) {
      return props.onTextAreaBlur(e);
    },
    onFocus: props.onTextAreaFocus,
    placeholder: props.placeholder || "Enter Input",
    autoSize: {
      minRows: 4
    }
  }))));
};